/**
 * Bootstrap + Turbo Integration
 *
 * Handles cleanup and reinitialization of Bootstrap components when Turbo
 * modifies the DOM. Bootstrap stores component instances on DOM elements,
 * and these instances must be properly disposed when elements are removed
 * to prevent stale state from interfering with new elements.
 */

import type { Dropdown } from "bootstrap"

/**
 * Dispose all open Bootstrap dropdowns.
 *
 * When a turbo-stream replaces an element containing an open dropdown,
 * Bootstrap's internal state becomes inconsistent if dispose() isn't called.
 * This can prevent dropdowns from opening properly on replacement elements.
 */
function disposeOpenDropdowns(): void {
  document.querySelectorAll(".dropdown-menu.show").forEach((menu) => {
    const toggle =
      menu.previousElementSibling?.matches('[data-bs-toggle="dropdown"]')
        ? menu.previousElementSibling
        : menu.parentElement?.querySelector('[data-bs-toggle="dropdown"]')

    if (toggle) {
      const dropdown = globalThis.bootstrap.Dropdown.getInstance(
        toggle
      ) as Dropdown | null
      if (dropdown) {
        dropdown.dispose()
      }
    }
  })
}

// Clean up dropdowns before Turbo stream renders to prevent stale state
document.addEventListener("turbo:before-stream-render", disposeOpenDropdowns)
